<template>
  <div class="text-justify">
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('4')"></h5>
      </legend>
    </div>

    <form-v2-csdm-detail-responsable-index
      :title="$store.getters.getTag('4.1.T')"
      :subtitle="$store.getters.getTag('4.1.S')"
      :footer="$store.getters.getTag('4.1.F')"
      type="RDSEC"
      :disabled="disabled"
      :activity="activity"
    />

    <form-v2-csdm-detail-responsable-index
      :title="$store.getters.getTag('4.2.T')"
      :subtitle="$store.getters.getTag('4.2.S')"
      :footer="$store.getters.getTag('4.2.F')"
      type="PDEA"
      :disabled="disabled"
      :activity="activity"
    />

    <form
      ref="form"
      data-url="/details"
      class="mb-0"
      :class="{ 'loading-opacity': preloader }"
    >
      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5 v-html="$store.getters.getTag('4.3')"></h5>
        </legend>

        <div class="col-12">
          <div class="form-group">
            <app-input
              type="radio-buttons"
              :list="confirm"
              v-model="inputs.other_activities"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12" v-if="inputs.other_activities">
          <div class="form-group">
            <label v-html="$store.getters.getTag('4.3.1')"></label>
            <app-input
              type="textarea"
              v-model="inputs.other_activities_description"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5 v-html="$store.getters.getTag('4.4')"></h5>
        </legend>

        <div class="col-md-12">
          <div class="form-group">
            <app-input
              type="textarea"
              v-model="inputs.financing_operations"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5 v-html="$store.getters.getTag('4.5')"></h5>
        </legend>

        <div class="col-md-12">
          <div class="form-group">
            <app-input
              type="radio-buttons"
              :list="confirm"
              v-model="inputs.more_schemes"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <div class="row" v-if="!disabled">
        <div class="col-12 mt-3">
          <button type="submit" class="btn btn-primary" @click.prevent="submit">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import moment from "moment";

export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },

  computed: {
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      return !["100", "112"].includes(this.status);
    },

    showFormResponsableAdd() {
      return (
        this.$store.state.accreditation.app != null &&
        [7].includes(
          this.$store.state.accreditation.app.accreditation_activity_id
        )
      );
    },

    showOtherActivities() {
      return (
        this.$store.state.accreditation.app != null &&
        ![1, 3].includes(
          this.$store.state.accreditation.app.accreditation_activity_id
        )
      );
    },

    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
  },

  created() {
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      const data = { ...this.inputs };
      data.consultation_date = this.dateToString(data.consultation_date);
      this.save(data);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const { data } = res.data;
      this.inputs = data;
      this.inputs.consultation_date = this.stringToDate(data.consultation_date);
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;

      this.axiosGet(
        `/details/show?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.inputs = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },

    stringToDate(date) {
      return date != null ? new Date(date) : null;
    },
  },
};
</script>
